module.exports = __webpack_public_path__ + "img/second_icon_xuechexuzhi@2x.4b28465b.png";